export const environment = {
    // Specifically used by PingAuthenticationModule in app.module.ts.
    authority: 'https://idp.aa.com',
    clientId: 'cers_prod',
    idle_threshold: 57600,
    timeout_duration: 60,
    use_html5_routing: false,
    load_user_info: true,
    logLevel: 0,
    logoutURL: 'https://pfloginapp.cloud.aa.com/api/palogout?TargetResource=https://cloud.cers.aa.com',
    // Outside of PingAuthenticationModule.
    apiUri: 'https://cersapi.aa.com/SSEHub.CERSPortal/2.0',
    encryptKey: '16D71B81C42E4FA7AC16B2BDEA7E53E9',
    production: true,
    appUrl: 'https://cloud.cers.aa.com',
    loginUrl: 'https://cloud.cers.aa.com',
    ssoEndpoint: 'https://pfloginapp.cloud.aa.com/',
    bypassSSO: false,
    serviceWorker: true,
    envName: 'prod',
    userOverride: null,
    cognosUrl: 'https://cognos.aa.com/cers-interactive',
    scope: 'openid profile offline_access',
};
